import { Router } from '@angular/router';
import { inject } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { scrollToFirstInvalid } from '../utils/scroll-to-invalid';

export const SHARED_UTILS = () => {
    const router = inject(Router);
    return {
        navigateTo(path: string): void {
            router.navigate([path]);
        },
        // Going on from a step that is not complete shows what is missing: its fields are marked and the first one is scrolled to.
        stepForward(stepper: MatStepper): void {
            const control = stepper.selected?.stepControl;
            if (control?.invalid) {
                control.markAllAsTouched();
                scrollToFirstInvalid();
                return;
            }

            stepper.next();
        },
        stepBack(stepper: MatStepper): void {
            stepper.previous();
        },
        isNull(value: any): boolean {
            return value === null || value === undefined || value === '';
        }
    };
};